import type { BusinessErrorCode } from "~served/configs/business-error";
import { errorToastOptions } from "~served/ui-comps/toast";

interface GraphQLErrorToastBrowserActions {
	reloadPage: () => void;
	copyReference: (reference: string) => Promise<unknown>;
}

interface GraphQLErrorToastInput {
	message: string;
	code?: BusinessErrorCode;
	isServedFault: boolean;
	reference?: string;
}

const browserActions: GraphQLErrorToastBrowserActions = {
	reloadPage: () => window.location.reload(),
	copyReference: (reference) => navigator.clipboard.writeText(reference),
};

export const createGraphQLErrorToast = (
	{ message, code, isServedFault, reference }: GraphQLErrorToastInput,
	actions: GraphQLErrorToastBrowserActions = browserActions,
) => {
	const description = reference ? `Ref: ${reference}` : undefined;

	if (code === "ITEMS_QUANTITY_MISMATCH" || code === "ORDER_SNAPSHOT_STALE") {
		return {
			message,
			options: {
				description,
				action: {
					label: "Reload",
					onClick: actions.reloadPage,
				},
			},
		};
	}

	return {
		message,
		options: errorToastOptions(isServedFault, reference, actions.copyReference),
	};
};
